import React from 'react';
import PropTypes from 'prop-types';
import withSelfServeCreatorGroup from 'withSelfServeCreator/withSelfServeCreatorGroup';
import SelfServeGroupPopup from 'Popups/SelfServeBuilderPopups/SelfServeGroupPopup';

const MINIMUM_WIDTH = 30;

export class CheckBoxPopup extends React.PureComponent {
  render() {
    const { groupData, popupId } = this.props;
    const isAnyCheckBoxSelected = groupData && groupData.length > 0;
    const isCurrentCheckBoxSelected = groupData && groupData.indexOf(popupId) >= 0;

    return (
      <SelfServeGroupPopup
        {...this.props}
        isAnyItemSelected={isAnyCheckBoxSelected}
        isCurrentItemSelected={isCurrentCheckBoxSelected}
      >
        <div
          className={`checkbox-popup ${this.props.isActivePopup ? 'active' : ''}`}
          style={{
            width: this.props.width,
            height: this.props.height,
          }}
        >
          <div className="checkbox-popup-inner" />
        </div>
      </SelfServeGroupPopup>
    );
  }
}

CheckBoxPopup.defaultProps = {
  isActivePopup: false,
  groupData: [],
};

CheckBoxPopup.propTypes = {
  height: PropTypes.number.isRequired,
  isActivePopup: PropTypes.bool,
  width: PropTypes.number.isRequired,
  groupData: PropTypes.arrayOf(PropTypes.string),
  popupId: PropTypes.string.isRequired,
};

const resizeProps = {
  isSquare: true,
  minWidth: MINIMUM_WIDTH,
};

export default withSelfServeCreatorGroup(CheckBoxPopup, {
  withDragAndResizeProps: { resizeProps },
});



// WEBPACK FOOTER //
// ./src-react/Popups/SelfServeBuilderPopups/CheckBoxPopup.jsx